"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryOrderStore = void 0;
const api_1 = require("client/api");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const logger_1 = require("shared/logger");
const log = new logger_1.Logger("users/store");
class InventoryOrderStore {
    constructor() {
        this.intentOrderMeta = null;
        this.user = { loading: true };
        this.distributors = [];
        this.distributorInventories = [];
        this.orderTrackingDetails = [];
        this.orderTrackingCreditDetails = [];
        this.distributorInventoriesByInventoryId = [];
        this.distributorInventoriesCart = [];
        this.rulesList = [];
        this.purchaseOrders = [];
        this.inventoryGroups = { value: [] };
        this.siteDistributors = [];
        this.financialPurchaseOrders = [];
        this.purchaseOrderToEdit = null;
        this.purchaseOrderIntents = [];
        this.invoiceMetas = [];
        this.showDropzone = false;
        this.poIdCurrentlyViewing = "";
        this.currentBatchQtyEdit = 0;
        this.availableBackorderDistributors = [];
        this.poMailMessages = [];
        this.showLoader = false;
        // C-097_Distributors pagination
        this.totalProviderPage = 1;
        this.currentPage = 1;
        this.resetIntentOrderMeta = () => {
            this.intentOrderMeta = null;
        };
        this.loadAvailableDistributors = async (query) => {
            const result = await api_1.InventoryOrderEndpoint.listavailabledistributors.apiCall({ query });
            if (api_1.isError(result)) {
                console.log("Error in loading available Distributos", result);
            }
            else {
                console.log("Successfuly loaded available distributors", result);
                this.availableBackorderDistributors = result.distributors;
            }
        };
        this.saveOrderTrackingDetails = async (trackingDetails, creditDetails, purchaseOrderId, site) => {
            const result = await api_1.InventoryOrderEndpoint.saveordertrackingdetails.apiCall(null, {
                creditDetails,
                purchaseOrderId,
                site,
                trackingDetails
            });
            if (api_1.isError(result)) {
                console.log("Error in saving order tracking details", result);
            }
            else {
                console.log("successfully saved order tracking details", result);
            }
        };
        this.addOrderTrackingDetail = async (newTrackingDetail, purchaseOrderId, site) => {
            const result = await api_1.InventoryOrderEndpoint.addordertrackingdetail.apiCall(null, {
                newTrackingDetail,
                purchaseOrderId,
                site
            });
            if (api_1.isError(result)) {
                console.log("Error in adding new order tracking detail", result);
            }
            else {
                console.log("successfully added new order tracking detail", result);
            }
        };
        this.addOrderTrackingCreditDetail = async (newCreditDetail, purchaseOrderId, site) => {
            const result = await api_1.InventoryOrderEndpoint.addordertrackingcreditdetail.apiCall(null, {
                newCreditDetail,
                purchaseOrderId,
                site
            });
            if (api_1.isError(result)) {
                console.log("Error in adding new order tracking credit detail", result);
            }
            else {
                console.log("successfully added new order tracking credit detail", result);
            }
        };
        this.listOrderTrackingDetails = async (purchaseOrderId) => {
            const query = {
                purchaseOrderId
            };
            const result = await api_1.InventoryOrderEndpoint.listordertrackingdetails.apiCall({ query });
            if (api_1.isError(result)) {
                console.error("Error in listing order tracking details", result.code);
            }
            else {
                console.info("Successfully loaded new order tracking details");
                this.orderTrackingDetails = result.orderTrackingDetails;
                console.log("this.orderTrackingDetails", this.orderTrackingDetails);
            }
        };
        this.listOrderTrackingCreditDetails = async (purchaseOrderId) => {
            const query = {
                purchaseOrderId
            };
            const result = await api_1.InventoryOrderEndpoint.listordertrackingcreditdetails.apiCall({ query });
            if (api_1.isError(result)) {
                console.error("Error in listing order tracking credit details", result.code);
            }
            else {
                console.info("Successfully loaded new order tracking credit details");
                this.orderTrackingCreditDetails = result.orderTrackingCreditDetails;
                console.log("this.orderTrackingCreditDetails", this.orderTrackingCreditDetails);
            }
        };
        this.findInventorySite = async (siteId, inventoryId) => {
            const query = {
                inventoryId,
                siteId
            };
            const result = await api_1.InventoryOrderEndpoint.findinventorysite.apiCall({
                query
            });
            console.log("resutl from findinventorySite is", result);
            if (api_1.isError(result)) {
                console.error("Error in finding inventory site", result.code);
                return null;
            }
            return result.inventorySite;
        };
        this.cancelPoInventory = async (purchaseOrderId, poInventory) => {
            const response = await api_1.InventoryOrderEndpoint.cancelpoinventory.apiCall(null, { poInventory, purchaseOrderId });
            if (api_1.isError(response)) {
                log.error("Error in canceling po inventory", response.code);
            }
            else {
                log.info("No error in canceling po inventory");
            }
        };
        this.deleteInvoiceDocument = async (invoiceUploadId) => {
            const response = await api_1.InventoryOrderEndpoint.deleteinvoicedocument.apiCall(null, { invoiceUploadId });
            if (api_1.isError(response)) {
                log.info("error in deleting invoice document", response.code);
            }
            else {
                log.info("no error in deleteing invoice document", response);
            }
        };
        this.uploadInvoice = async (files, poId) => {
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newInvoice", file, file.name);
            });
            const response = await api_1.InventoryOrderEndpoint.uploadinvoice.apiCall({
                query: {
                    poId
                }
            }, formData);
            if (api_1.isError(response)) {
                log.info("error in invoice uploaded", response.code);
            }
            else {
                log.info("no error in invoice uploaded", response);
            }
        };
        this.updateAssetsDescriptions = async (uploads) => {
            console.log("uploads inventoryorderstore", uploads);
            const result = await api_1.InventoryOrderEndpoint.updateassetsdescriptions.apiCall(null, { uploads });
            if (api_1.isError(result)) {
                console.error("Error updating assets descriptions in inventoryorderstore");
            }
            else {
                console.info("Successfully updated assets descriptions in inventoryorderstore");
            }
        };
        this.listPurchaseOrdersWithinDateRange = async (query = { siteId: [0] }) => {
            const response = await api_1.InventoryOrderEndpoint.listwithindaterange.apiCall({
                query
            });
            if (api_1.isError(response)) {
                console.error("Error in listing purchase orders within date range.");
            }
            else {
                this.financialPurchaseOrders = response.purchaseOrders;
            }
        };
        this.listInvoices = async (query) => {
            const response = await api_1.InventoryOrderEndpoint.listinvoices.apiCall({
                query
            });
            if (api_1.isError(response)) {
                log.info("error in listing invoices");
            }
            else {
                log.info("no error in listing invoice ");
                this.invoiceMetas = response.invoiceMetas;
            }
        };
        this.loadPurchaseOrderIntents = async (siteId) => {
            const result = await api_1.InventoryOrderEndpoint.loadpurchaseorderintents.apiCall({
                query: {
                    siteId
                }
            });
            if (api_1.isError(result)) {
                alert("error in loading purchase order intent in inventory order store");
                console.error(result);
            }
            else {
                // console.log("result is ", result);
                // return result.purchaseOrderIntents;
                this.purchaseOrderIntents = result.purchaseOrderIntents;
            }
        };
        this.updatePurchaseOrderIntents = async (siteId, savedPurchaseOrderId) => {
            const result = await api_1.InventoryOrderEndpoint.updatepurchaseorderintents.apiCall({
                query: {
                    savedPurchaseOrderId,
                    siteId
                }
            });
            if (api_1.isError(result)) {
                alert("error in updating purchase order intent in inventory order store");
                console.error(result);
            }
            else {
                // console.log("result is ", result);
                // return result.purchaseOrderIntents;
            }
        };
        this.createDistributor = async (distributor) => {
            let fullEmail = distributor.contactEmail;
            if (distributor.contactEmailTwo) {
                fullEmail = fullEmail.concat(";", distributor.contactEmailTwo);
            }
            if (distributor.contactEmailThree) {
                fullEmail = fullEmail.concat(";", distributor.contactEmailThree);
            }
            const newDist = {
                contactEmail: fullEmail,
                name: distributor.name
            };
            const result = await api_1.InventoryOrderEndpoint.createdistributor.apiCall(null, { distributor: newDist });
            if (api_1.isError(result)) {
                alert("error in create distributor");
                return false;
            }
            return result;
        };
        this.updateDistributor = async (distributor) => {
            const result = await api_1.InventoryOrderEndpoint.updatedistributor.apiCall(null, { distributor });
            if (api_1.isError(result)) {
                alert("error in update distributor");
                return false;
            }
            return result;
        };
        this.saveDistributorInventories = async (distributor) => {
            const result = await api_1.InventoryOrderEndpoint.savedistributorinventories.apiCall(null, { distributor });
            if (api_1.isError(result)) {
                alert("error in saving distributor inventories");
                console.log("error is ", result);
            }
            else {
                this.distributorInventories = result.distributorInventories;
                return result;
            }
        };
        // C-097_Distributors
        this.listDistributors = async (query = { page: 1, limit: 25 }) => {
            const result = await api_1.InventoryOrderEndpoint.listdistributors.apiCall({ query });
            if (api_1.isError(result)) {
                this.showLoader = false;
                // log error
                throw new Error("error in listing distributors");
            }
            else {
                this.showLoader = false;
                this.distributors = result.distributors;
                this.totalProviderPage = result.totalPages; // C-097_Distributors // C-097
                this.currentPage = result.currentPage; // C-097_Distributors   // C-097 
            }
        };
        // C-097 delete distributor
        this.listDeletedDistributors = async (query = { page: 1, limit: 25 }) => {
            this.showLoader = true;
            const result = await api_1.InventoryOrderEndpoint.listdeleteddistributors.apiCall({ query });
            if (api_1.isError(result)) {
                this.showLoader = false;
                // log error
                throw new Error("error in listing deleted distributors");
            }
            else {
                this.showLoader = false;
                this.distributors = result.distributors;
                this.totalProviderPage = result.totalPages; // for pagination // C-097
                this.currentPage = result.currentPage; // for pagination   // C-097 
            }
        };
        this.checkDeletedDistributors = async (distIds) => {
            const result = await api_1.InventoryOrderEndpoint.checkdeleteddistributors.apiCall(null, { distIds });
            if (api_1.isError(result)) {
                // log error
                throw new Error("error in checking deleted distributors");
            }
            else {
                return result.deletedDistributors;
            }
        };
        this.listInventoryGroups = async () => {
            const result = await api_1.InventoryOrderEndpoint.listinventorygroups.apiCall();
            if (api_1.isError(result)) {
                throw new Error("error in listing inventory groups");
            }
            else {
                this.inventoryGroups = { value: result.inventoryGroups };
            }
        };
        this.loadDistributorInventories = async (distributorId) => {
            const result = await api_1.InventoryOrderEndpoint.listdistributorinventories.apiCall(null, { distributorId });
            // console.log("result in distributor inventories:", result);
            if (api_1.isError(result)) {
                // log error
                throw new Error("error in loading distributorinventories");
            }
            else {
                this.distributorInventories = result.distributorInventories;
            }
        };
        this.listDistributorInventoriesByInventoryId = async (inventoryId) => {
            const result = await api_1.InventoryOrderEndpoint.listdistributorinventoriesbyinventoryid.apiCall(null, { inventoryId });
            if (api_1.isError(result)) {
                // log error
                throw new Error("error in loading distributorinventories");
            }
            else {
                this.distributorInventoriesByInventoryId =
                    result.distributorInventoryiesByInventoryId;
            }
        };
        this.loadDistributorInventoriesCart = async (inventoryIds, siteId) => {
            const result = await api_1.InventoryOrderEndpoint.listdistributorinventoriescart.apiCall(null, { inventoryIds, siteId });
            if (api_1.isError(result)) {
                throw new Error("error in loading distributorinventoriescart");
            }
            else {
                this.distributorInventoriesCart = result.distributorInventoriesCart;
            }
        };
        // lavk2 C-046
        //Update to Where Pop Up is Associated C-046.20611
        this.loadDistributorInventoryWithDist = async (inventoryId, siteId) => {
            try {
                const result = await api_1.InventoryOrderEndpoint.listdistributorinventory.apiCall(null, { inventoryId, siteId });
                if (api_1.isError(result)) {
                    console.log("error is", result);
                    return [];
                }
                return result.inventoryData;
            }
            catch (error) {
                console.log(error, "error in loadDistributorInventoryWithDist");
            }
        };
        this.loadSiteComapnyDetailsInfo = async (siteId) => {
            const result = await api_1.InventoryOrderEndpoint.listsiteComapnyDetails.apiCall({
                query: { siteId }
            });
            if (api_1.isError(result)) {
                throw new Error("error in loading site distributors");
            }
            else {
                return result.companyData;
            }
        };
        this.loadSiteDistributors = async (siteId) => {
            const result = await api_1.InventoryOrderEndpoint.listsitedistributors.apiCall({
                query: { siteId }
            });
            if (api_1.isError(result)) {
                throw new Error("error in loading site distributors");
            }
            else {
                this.siteDistributors = result.siteDistributors;
            }
        };
        this.loadDistributorInventoriesBySite = async (siteId, inventoryId) => {
            const result = await api_1.InventoryOrderEndpoint.listdistributorinventoriesbysite.apiCall({
                query: {
                    inventoryId,
                    siteId
                }
            });
            if (api_1.isError(result)) {
                console.log("error is", result);
                return [];
            }
            return result.distributorInventories;
        };
        this.deleteDistributor = async (distributor) => {
            const result = await api_1.InventoryOrderEndpoint.deleteDistributor.apiCall(null, { distributor });
        };
        this.activateDistributor = async (distributor, restore) => {
            const result = await api_1.InventoryOrderEndpoint.activateDistributor.apiCall(null, { distributor, restore });
        };
        this.createRule = async (rule) => {
            const result = await api_1.InventoryOrderEndpoint.createrule.apiCall(null, {
                rule
            });
            if (api_1.isError(result)) {
                alert("error in create rule");
            }
            else {
                console.log("success in create rule");
            }
        };
        this.saveRule = async (rule) => {
            const result = await api_1.InventoryOrderEndpoint.saverule.apiCall(null, {
                rule
            });
            if (api_1.isError(result)) {
                alert("error in save rule");
            }
            else {
                console.log("success in save rule");
            }
        };
        this.deleteRule = async (rule) => {
            const result = await api_1.InventoryOrderEndpoint.deleterule.apiCall(null, {
                rule
            });
            if (api_1.isError(result)) {
                alert("error in save rule");
            }
            else {
                console.log("success in save rule");
            }
        };
        this.addNotificationMethod = async (rule, notification) => {
            const result = await api_1.InventoryOrderEndpoint.addnotificationmethod.apiCall(null, {
                notification,
                rule
            });
            if (api_1.isError(result)) {
                throw new Error("error in addnotificationmethod");
            }
            else {
                console.log("Successfully added notification method");
            }
        };
        this.removeNotificationMethod = async (rule, notification) => {
            const result = await api_1.InventoryOrderEndpoint.removenotificationmethod.apiCall(null, {
                notification,
                rule
            });
            if (api_1.isError(result)) {
                throw new Error("error in removenotificationmethod");
            }
            else {
                console.log("Successfully removed notification method");
            }
        };
        this.loadPurchaseRules = async (query) => {
            const result = await api_1.InventoryOrderEndpoint.listrules.apiCall({ query });
            if (api_1.isError(result)) {
                throw new Error("error in loading loadRules");
            }
            else {
                this.rulesList = result.rules;
            }
        };
        this.sendSubmissionAlert = async () => {
            const site = store_2.usersStore.user.value.siteUser && store_2.usersStore.user.value.site;
        };
        this.sendPurchaseOrderSubmissionAlert = async (purchaseOrder) => {
            const { id, pharmacyName, orderInventories = [], site, orderTotalCost } = purchaseOrder;
            const groupIds = [1, 2, 3, 4];
            function buildAlertMessage(purchaseOrder) {
                return `
                <div class="po-summary-container">
                  <h2 class="po-summary-header">PO # ${id} Summary</h2>
                  <div class="po-summary-content">
                    <h4 class="po-summary-subtitle">A new purchase order is pending for approval.</h4>
                    <div class="po-summary-indent">
                      <p class="transaction-id"><strong>Transaction id</strong>: ${id}</p>
                      <p><strong>Pharmacy name</strong>: ${pharmacyName}</p>
                      <p><strong>Inventory count</strong>: ${orderInventories.length}</p>
                      <p><strong>Total cost</strong>: $${orderTotalCost.toFixed(2)}</p>
                    </div>

                    <div class="po-review-button-container">
                      <a href="/order/review/${id}"
                        ><button class="po-review-button">REVIEW ORDER</button></a
                      >
                    </div>
                  </div>
                </div>
      `;
            }
            const alert = {
                alertType: store_1.AlertType.Null,
                groupIds,
                message: buildAlertMessage(purchaseOrder),
                siteId: site ? site.id : null,
                subject: `${site && "("} ${site ? site.displayName : "(No pharmacy name)"} ${site && ")"} PO ${id !== null && id !== void 0 ? id : "(No purchase order id)"} pending approval`
            };
            store_1.dashboardStore.createAlert(alert);
        };
        this.sendPurchaseOrderSubmissionDecisionAlert = async (purchaseOrder, decision) => {
            const { id, pharmacyName, orderInventories = [], orderTotalCost, site } = purchaseOrder;
            // clinic admin, clinic manager, clinic user
            const groupIds = [4, 5, 6];
            function buildAlertMessage(purchaseOrder) {
                return `
                <div class="po-summary-container">
                  <h2 class="po-summary-header">PO# ${id} ${decision}</h2>
                  <div class="po-summary-content">
                    <h4 class="po-summary-subtitle">The purchase order number ${id} has been ${decision}</h4>
                    <div class="po-summary-indent">
                      <p class="transaction-id"><strong>Transaction id</strong>: ${id}</p>
                      <p><strong>Pharmacy name</strong>: ${pharmacyName}</p>
                      <p><strong>Inventory count</strong>: ${orderInventories.length}</p>
                      <p><strong>Total cost</strong>: $${orderTotalCost.toFixed(2)}</p>
                    </div>

                    <div class="po-review-button-container">
                      <a href="/order/review/${id}"
                        ><button class="po-review-button">REVIEW ORDER</button></a
                      >
                    </div>
                  </div>
                </div>
      `;
            }
            const siteId = site ? site.id : null;
            const subject = `${site && "("} ${site ? site.displayName : "(No pharmacy name)"} ${site && ")"} PO ${id !== null && id !== void 0 ? id : "(No purchase order id)"} ${decision}`;
            const alert = {
                alertType: store_1.AlertType.Null,
                groupIds,
                message: buildAlertMessage(purchaseOrder),
                siteId,
                subject
            };
            store_1.dashboardStore.createAlert(alert);
        };
        this.sendEmailAlert = async (emailTemplate, purchaseOrder, mailToEmail, isPOEmailAssociated // D-023
        ) => {
            // console.log('purchase order table is ', emailTemplate);
            const result = await api_1.InventoryOrderEndpoint.sendemailalert.apiCall(null, {
                emailTemplate,
                mailToEmail,
                purchaseOrder,
                isPOEmailAssociated
            }); // D-023
            if (api_1.isError(result)) {
                alert("error in sending mail alert");
                // console.log("result error is ", result);
                return null;
            }
            // console.log("result is ", result);
            return result;
        };
        this.sendEmailOrderToDistributors = async (distributorOrders) => {
            // console.log("distributorOrders ------is ", distributorOrders);
            const result = await api_1.InventoryOrderEndpoint.sendemailordertodistributor.apiCall(null, { distributorOrders });
        };
        this.createPurchaseOrder = async (purchaseOrder) => {
            const result = await api_1.InventoryOrderEndpoint.createpurchaseorder.apiCall(null, {
                purchaseOrder
            });
            if (api_1.isError(result)) {
                throw new Error(result.code);
            }
            else {
                // console.log("result is ", result);
                return result.savedOrder;
            }
        };
        this.updateExpectedBackorderDate = async (poInventory, purchaseOrder, expectedDate) => {
            const result = await api_1.InventoryOrderEndpoint.updateexpectedbackorderdate.apiCall(null, {
                expectedDate,
                poInventory,
                purchaseOrder
            });
            if (api_1.isError(result)) {
                console.error("Error updating inventorysite backorder date", result);
            }
            else {
                console.info("inventorysite expected backorder date updated");
            }
        };
        this.createBackorder = async (poInventory, purchaseOrder) => {
            const result = await api_1.InventoryOrderEndpoint.createbackorder.apiCall(null, {
                poInventory,
                purchaseOrder
            });
            if (api_1.isError(result)) {
                console.error("Error creating backorder", result);
            }
            else {
                console.info("Created backorder");
                // return result.savedOrder;
            }
        };
        this.updatePurchaseOrder = async (purchaseOrder, resubmission) => {
            // console.log("resubmission is++++++++++++++++++++++ ", resubmission);
            const result = await api_1.InventoryOrderEndpoint.updatepurchaseorder.apiCall(null, {
                purchaseOrder,
                resubmission
            });
            if (api_1.isError(result)) {
                throw new Error(result.code);
            }
            else {
                // console.log("result from updatePurchaseOrder is ", result);
                return result.purchaseOrder;
            }
        };
        this.loadPurchaseOrderById = async (id) => {
            const result = await api_1.InventoryOrderEndpoint.listpurchaseorder.apiCall({
                params: { id }
            });
            if (api_1.isError(result)) {
                throw new Error(result.code);
            }
            else {
                // console.log("result is ", result);
                return result.purchaseOrder;
            }
        };
        this.loadPurchaseOrders = async (query) => {
            const result = await api_1.InventoryOrderEndpoint.listpurchaseorders.apiCall({
                query
            });
            // console.log("result is ", result);
            if (api_1.isError(result)) {
                throw new Error(result.code);
            }
            else {
                // console.log("result is ", result);
                this.purchaseOrders = result.purchaseOrders;
                return result.purchaseOrders;
            }
        };
        this.updatePurchaseOrderStatus = async (purchaseOrderDecision) => {
            const result = await api_1.InventoryOrderEndpoint.updatepostatus.apiCall(null, {
                purchaseOrderDecision
            });
            // console.log("result is ", result);
            if (api_1.isError(result)) {
                return false;
            }
            // console.log("result is ", result);
            return result;
        };
        this.getPoMailMessages = async (mailIds) => {
            const result = await api_1.InventoryOrderEndpoint.getpomailmessages.apiCall(null, {
                mailIds
            });
            if (api_1.isError(result)) {
                this.poMailMessages = [];
            }
            else {
                this.poMailMessages = result.mailMessages;
            }
        };
        mobx_1.autorun(async () => {
            this.user = await store_2.usersStore.user;
        });
    }
}
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "intentOrderMeta", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "distributors", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "distributorInventories", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "orderTrackingDetails", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "orderTrackingCreditDetails", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "distributorInventoriesByInventoryId", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "distributorInventoriesCart", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "rulesList", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "purchaseOrders", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "inventoryGroups", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "siteDistributors", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "financialPurchaseOrders", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "purchaseOrderToEdit", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "purchaseOrderIntents", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "invoiceMetas", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "showDropzone", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "poIdCurrentlyViewing", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "currentBatchQtyEdit", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "availableBackorderDistributors", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "poMailMessages", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "showLoader", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "totalProviderPage", void 0);
__decorate([
    mobx_1.observable
], InventoryOrderStore.prototype, "currentPage", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "resetIntentOrderMeta", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadAvailableDistributors", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "saveOrderTrackingDetails", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "addOrderTrackingDetail", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "addOrderTrackingCreditDetail", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listOrderTrackingDetails", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listOrderTrackingCreditDetails", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "findInventorySite", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "cancelPoInventory", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "deleteInvoiceDocument", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "uploadInvoice", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "updateAssetsDescriptions", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listPurchaseOrdersWithinDateRange", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listInvoices", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadPurchaseOrderIntents", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "updatePurchaseOrderIntents", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "createDistributor", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "updateDistributor", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "saveDistributorInventories", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listDistributors", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listDeletedDistributors", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "checkDeletedDistributors", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listInventoryGroups", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadDistributorInventories", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "listDistributorInventoriesByInventoryId", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadDistributorInventoriesCart", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadDistributorInventoryWithDist", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadSiteComapnyDetailsInfo", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadSiteDistributors", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadDistributorInventoriesBySite", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "deleteDistributor", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "activateDistributor", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "createRule", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "saveRule", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "deleteRule", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "addNotificationMethod", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "removeNotificationMethod", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadPurchaseRules", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "sendSubmissionAlert", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "sendPurchaseOrderSubmissionAlert", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "sendPurchaseOrderSubmissionDecisionAlert", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "sendEmailAlert", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "sendEmailOrderToDistributors", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadPurchaseOrderById", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "loadPurchaseOrders", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "updatePurchaseOrderStatus", void 0);
__decorate([
    mobx_1.action
], InventoryOrderStore.prototype, "getPoMailMessages", void 0);
exports.inventoryOrderStore = new InventoryOrderStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/store.ts
// module id = 148
// module chunks = 0